import { useEffect } from 'react'
import styles from './ViewModal.module.scss'
import BidMsrpButton from 'elements/BidMsrpButton/BidMsrpButton'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default function InvoiceModal({
  showModal,
  negativeZ,
  item,
  toggleModal,
}: any) {
  const tableHeadingList = [
    'Title',
    'Description',
    'Brand',
    'Model',
    'Manufacturer',
    'MPN',
    'MSRP',
    'Qty',
    'Unit',
    'Width',
    'Height',
    'Length',
    'Weight',
  ]

  const renderHeadingList = (list: any) => {
    return list.map((item: any) => (
      <th
        className="font-bold !bg-bidfta-blue-dark text-white py-4 text-xs px-4 border-r md:border-none border-bidfta-gray-border"
        key={item}
      >
        {item}
      </th>
    ))
  }

  useEffect(() => {
    const closeModal = (e: any) => {
      if (e.key === 'Escape') {
        toggleModal(false, 'View')
      }
    }
    window.addEventListener('keyup', closeModal)
    return () => window.removeEventListener('keyup', closeModal)
  }, []) // eslint-disable-line
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div
      className={`transition-opacity duration-200 fixed top-0 flex justify-center items-center w-full h-screen p-4 bg-black/30 ${
        negativeZ ? styles.hide_modal : 'z-50'
      } ${!showModal ? ` opacity-0` : 'opacity-100'}`}
      role="none"
      onClick={() => toggleModal(false, 'View')}
    >
      <div
        className={`${styles.modal} relative p-8 md:p-0 bg-white rounded-lg max-h-full	overflow-y-scroll`}
        role="none"
        onClick={(e: any) => e.stopPropagation()}
      >
        <button
          className="absolute top-0 right-0 px-3 py-1 text-xl md:hidden"
          type="button"
          onClick={() => toggleModal(false, 'View')}
        >
          &times;
        </button>
        <div className="md:grid md:gap-3">
          {/* Mobile Layout */}
          <div className="md:hidden">
            <Slider {...settings}>
              {item.containerLineItemList.map(
                (lineItem: any, index: number) => (
                  <div key={`line-item-${index}`}>
                    <table key={lineItem.id} className="mx-auto">
                      <tbody className="px-4 w-full border border-bidfta-gray-border text-sm">
                        {/* {renderTableContent(lineItem)} */}
                        {/* Title */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                            Title
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.title}
                          </td>
                        </tr>
                        {/* Description */}
                        <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                            Description
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.description}
                          </td>
                        </tr>
                        {/* Brand */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                            Brand
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.brand ? lineItem.brand : 'N/A'}
                          </td>
                        </tr>
                        {/* Model */}
                        <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                            Model
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.model ? lineItem.model : 'N/A'}
                          </td>
                        </tr>
                        {/* Manufacturer */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                            Manufacturer
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.manufacturer
                              ? lineItem.manufacturer
                              : 'N/A'}
                          </td>
                        </tr>
                        {/* MPN */}
                        <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                            MPN
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.mpn ? lineItem.mpn : 'N/A'}
                          </td>
                        </tr>
                        {/* MSRP */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="px-4 border-r border-bidfta-gray-border w-26">
                            <div className="flex items-center">
                              <h4 className="font-bold text-xs mr-1">MSRP</h4>
                              <BidMsrpButton />
                            </div>
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.msrp
                              ? `$${lineItem.msrp?.toFixed(2)}`
                              : 'N/A'}
                          </td>
                        </tr>
                        {/* Qty */}
                        <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                            Qty
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.quantity ? lineItem.quantity : 'N/A'}
                          </td>
                        </tr>
                        {/* Unit */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                            Unit
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.unitDescription
                              ? lineItem.unitDescription
                              : 'N/A'}
                          </td>
                        </tr>
                        {/* Width */}
                        <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                            Width
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.width ? lineItem.width : 'N/A'}
                          </td>
                        </tr>
                        {/* Height */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                            Height
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.height ? lineItem.height : 'N/A'}
                          </td>
                        </tr>
                        {/* Length */}
                        <tr className="border-b border-bidfta-gray-border bg-bidfta-green-tablelight py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border p-2 w-26">
                            Length
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.length ? lineItem.length : 'N/A'}
                          </td>
                        </tr>
                        {/* Weight */}
                        <tr className="border-b border-bidfta-gray-border py-2">
                          <td className="font-bold text-xs px-4 border-r border-bidfta-gray-border w-26">
                            Weight
                          </td>
                          <td className="text-bidfta-gray-dark/60 p-2">
                            {lineItem.weight ? lineItem.weight : 'N/A'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )
              )}
            </Slider>
          </div>
          {/* Desktop Layout */}
          <table className="hidden md:block desktop-table md:p-8">
            <thead>
              <tr className="border-b border-bidfta-gray-border py-2">
                {renderHeadingList(tableHeadingList)}
              </tr>
            </thead>
            <tbody className="px-4 w-full border border-bidfta-gray-border">
              {item.containerLineItemList.map(
                (lineItem: any, index: number) => (
                  <tr
                    key={lineItem.id}
                    className={`border-b border-bidfta-gray-border text-center ${
                      index % 2 ? 'bg-bidfta-green-tablelight' : ''
                    } py-2`}
                  >
                    {/* Title */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.title}
                    </td>
                    {/* Description */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.description}
                    </td>
                    {/* Brand */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.brand ? lineItem.brand : 'N/A'}
                    </td>
                    {/* Model */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.model ? lineItem.model : 'N/A'}
                    </td>
                    {/* Manufacturer */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.manufacturer ? lineItem.manufacturer : 'N/A'}
                    </td>
                    {/* MPN */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.mpn ? lineItem.mpn : 'N/A'}
                    </td>
                    {/* MSRP */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.msrp ? `$${lineItem.msrp?.toFixed(2)}` : 'N/A'}
                    </td>
                    {/* Qty */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.quantity ? lineItem.quantity : 'N/A'}
                    </td>
                    {/* Unit */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.unitDescription
                        ? lineItem.unitDescription
                        : 'N/A'}
                    </td>
                    {/* Width */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.width ? lineItem.width : 'N/A'}
                    </td>
                    {/* Height */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.height ? lineItem.height : 'N/A'}
                    </td>
                    {/* Length */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.length ? lineItem.length : 'N/A'}
                    </td>
                    {/* Weight */}
                    <td className="text-bidfta-gray-dark/60 p-2">
                      {lineItem.weight ? lineItem.weight : 'N/A'}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
